var map = {
	"./chat.png": "pB0o",
	"./customer-history.png": "K5e8",
	"./desktop-device-link.png": "iC2W",
	"./desktop-easy-login.png": "YaHt",
	"./nps-feedback.png": "BAY9",
	"./shop-management-video.png": "ME+G",
	"./team-management.png": "IOFb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1IgP";